import './testimonials.scss';
import React from 'react';
const data = [
  {
    id: 0,
    name: 'Ali Zia Khan',
    title: 'MERN Stack Developer @ HashPotato',
    img: 'assets/AliZia.1d9d0f07.jpg',
    icon: 'assets/twitter.png',
    desc: `Every plane needs a pilot, and I’m grateful you are ours.
      It’s amazing to see you manage a bazillion things in a short time. And you do it so efficiently.`,
  },
  {
    id: 1,
    name: 'Tabish Siddiqui',
    title: 'CEO @ HashPotato',
    img: 'assets/1620999462009.jpg',
    icon: '1620999462009.jpg',
    desc: 'Adeel is our amazing Full Stack Developer and Project Manager at HashPotato. His contributions to the business are countless.',
    featured: true,
  },
  {
    id: 2,
    name: 'Muhammad Hashir Uddin',
    title: `Mobile App Developer @ Central Depository Company`,
    img: 'assets/1641403019039.jpg',
    icon: 'assets/linkedin.png',
    desc: `Adeel is passionate about his career. He have great programming skills and he is really an expert of backend and have done dozens of projects. He is so kind and always ready to help the person in need.
     `,
  },
  {
    id: 3,
    name: 'Rabbiya Mehmood',
    title: `SQA Engineer @ Cloudnosys`,
    img: 'assets/rabbiya.jpeg',
    icon: 'assets/linkedin.png',
    desc: `There is no better colleague than Adeel. He is one of the most dedicated professionals I’ve worked with and is willing to give extra help whenever you need it. His expertise as a developer is considerable and appreciatable. I highly adore his positive attitude and confidence.`,
  },
];

export default function Testimonials() {
  const [selected, setSelected] = React.useState(0);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setSelected((prev) => (prev != data.length - 1 ? prev + 1 : 0));
    }, 2000);
    return () => clearTimeout(timer);
  });
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        <div className="testimonial-images">
          {data.map((item, index) => (
            <div
              className="image-container"
              onClick={() => setSelected(item.id)}
            >
              {item.id == selected && <div className="active"></div>}
              <img src={item.img} />
            </div>
          ))}
        </div>
        <div className="testimonial-comment">
          <h1> {data[selected]?.name}</h1>
          <h2> {data[selected]?.title}</h2>

          <div className="testimonial-desc">"{data[selected]?.desc}"</div>
        </div>

        {/* {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="" />
              <img
                className="user"
                src={d.img}
                alt=""
              />
              <img className="right" src={d.icon} alt="" />
            </div>
            <div className="center">
              {d.desc}
            </div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))} */}
      </div>
    </div>
  );
}
